import React from 'react';
import { useLanguage } from './LanguageContext';
import { ShieldCheck, Globe2, Heart, Award } from 'lucide-react';
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  const features = [{
    icon: <Award className="w-10 h-10 text-brand-teal" data-id="element-231" />,
    title: t('why.evidence'),
    desc: t('why.evidence.desc')
  }, {
    icon: <Globe2 className="w-10 h-10 text-brand-deep" data-id="element-232" />,
    title: t('why.culture'),
    desc: t('why.culture.desc')
  }, {
    icon: <ShieldCheck className="w-10 h-10 text-brand-lilac" data-id="element-233" />,
    title: t('why.bilingual'),
    desc: t('why.bilingual.desc')
  }, {
    icon: <Heart className="w-10 h-10 text-pink-500" data-id="element-234" />,
    title: t('why.compassion'),
    desc: t('why.compassion.desc')
  }];
  return <section id="about" className="py-14 md:py-20 bg-white" data-id="element-235">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
        <div className="text-center mb-10 md:mb-16" data-id="element-237">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-deep mb-4" data-id="element-238">
            {t('why.title')}
          </h2>
          <div className="w-20 h-1 bg-brand-teal mx-auto rounded-full" data-id="element-239"></div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-240">
          {features.map((feature, index) => <div key={index} className="text-center group" data-id="element-241">
              <div className="w-20 h-20 mx-auto bg-brand-light rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-sky/30 transition-colors duration-300" data-id="element-242">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-deep mb-3" data-id="element-243">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm" data-id="element-244">
                {feature.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}